import React from 'react';
import { Clock } from 'lucide-react';
import { TOKENS } from '../styles';

interface Props {
  title: string;
  sub: string;
  dueDate: string;
  method: string;
  onPreview: () => void;
}

export default function FilingCard({ title, sub, dueDate, method, onPreview }: Props) {
  return (
    <div style={{
      background: TOKENS.card,
      border: '1px solid ' + TOKENS.line,
      borderLeft: '4px solid ' + TOKENS.teal,
      borderRadius: 12,
      padding: '16px 18px',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 20,
    }}>
      <div style={{ flex: 1, minWidth: 190 }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: TOKENS.ink }}>{title}</div>
        <div style={{ fontSize: 13, color: TOKENS.dark, fontWeight: 600 }}>{sub}</div>
        <div>
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            fontSize: 12, padding: '4px 10px', borderRadius: 999,
            fontWeight: 700, marginTop: 8,
            background: TOKENS.neutralPill, color: TOKENS.dark,
          }}>
            <Clock size={14} strokeWidth={2.5} />
            Not due yet
          </span>
        </div>
      </div>
      <div>
        <div style={{ fontSize: 15, fontWeight: 700, color: TOKENS.ink }}>Due {dueDate}</div>
        <div style={{ fontSize: 12, color: TOKENS.dark, fontWeight: 600 }}>{method}</div>
      </div>
      <button
        onClick={onPreview}
        style={{
          fontFamily: 'inherit', fontWeight: 700, fontSize: 14,
          borderRadius: 10, padding: '10px 16px', cursor: 'pointer',
          border: '1px solid ' + TOKENS.lineStrong,
          background: 'white', color: TOKENS.ink,
        }}
      >
        Preview
      </button>
    </div>
  );
}